/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coral_Clear_Cat_CurlInputs */

const en_coral_clear_cat_curl = /** @type {(inputs: Coral_Clear_Cat_CurlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No surveys found`)
};

const de_coral_clear_cat_curl = /** @type {(inputs: Coral_Clear_Cat_CurlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Umfragen gefunden`)
};

/**
* | output |
* | --- |
* | "No surveys found" |
*
* @param {Coral_Clear_Cat_CurlInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coral_clear_cat_curl = /** @type {((inputs?: Coral_Clear_Cat_CurlInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coral_Clear_Cat_CurlInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coral_clear_cat_curl(inputs)
	return de_coral_clear_cat_curl(inputs)
});